/**
 * active-forhandler.ts — lagring av aktiv forhandler i nettleser-storage
 *
 * Separation of concerns: denne filen håndterer KUN lagring/lesing av
 * aktiv forhandler-ID. Ingen React-state, ingen HTTP-kall.
 *
 * Konvensjon (per instruksjon):
 * - Kun ID-en lagres — aldri navn eller andre felt.
 * - Nøkkel: "aktiv_forhandler"
 * - Hver gang bruker bytter, oppdateres verdien.
 *
 * Funksjoner:
 * 1. getActiveForhandlerId — leser aktiv forhandler-ID fra localStorage
 * 2. setActiveForhandlerId — lagrer aktiv forhandler-ID i localStorage
 */

/**
 * Storage-nøkkel for aktiv forhandler (per eksplisitt instruksjon).
 */
export const ACTIVE_FORHANDLER_STORAGE_KEY = 'aktiv_forhandler';

/**
 * 1. getActiveForhandlerId — leser aktiv forhandler-ID fra localStorage
 *
 * NB: Må kun kalles fra klienten (localStorage er ikke tilgjengelig under SSR).
 *
 * @returns forhandler-ID (string) eller null hvis ikke satt
 */
export function getActiveForhandlerId(): string | null {
  return localStorage.getItem(ACTIVE_FORHANDLER_STORAGE_KEY);
}

/**
 * 2. setActiveForhandlerId — lagrer aktiv forhandler-ID i localStorage
 *
 * Lagrer KUN ID-en (string) — ingen andre felt.
 * Kalles hver gang bruker bytter forhandler i switcher-panelet.
 *
 * NB: Må kun kalles fra klienten (localStorage er ikke tilgjengelig under SSR).
 *
 * @param id — forhandler-ID (string, som i JWT-nøkkelen for forhandler_name_cosmetic)
 */
export function setActiveForhandlerId(id: string): void {
  localStorage.setItem(ACTIVE_FORHANDLER_STORAGE_KEY, id);
}
